import React from "react";
import { Steps } from "antd";
import ForgotPasswordForm from "./utils/forgot-password-form";
import { ForgotPasswordViewProps } from "./types/forgot-password.types";


function ForgotPasswordView(props: ForgotPasswordViewProps) {

    return (
        <div className="forget-password-credentials">
            <Steps
                size="small"
                direction="vertical"
                current={props.step.active}
                onChange={props.onStepChange}
                items={[
                    {
                        title: 'OTP Generation',
                        status: props.step.generation.status,
                        disabled: props.step.generation.disabled,
                    },
                    {
                        title: 'OTP Verification',
                        status: props.step.verification.status,
                        disabled: props.step.verification.disabled,
                    },
                    {
                        title: 'Reset Password',
                        status: props.step.reset.status,
                        disabled: props.step.reset.disabled,
                    },
                ]}
            />

            <ForgotPasswordForm
                activeStep={props.step.active}
                onSubmit={props.onSubmit}
                otpTimer={props.otpTimer}
                passwordSessionTimer={props.passwordSessionTimer}
                generateOtp={props.generateOtp}
            />
        </div>
    )
}

export default ForgotPasswordView;
